import { Autocomplete, AutocompleteChangeReason, FormControl, TextField } from "@mui/material";
import { TooltipChip } from "../TooltipChip";
import React, { SyntheticEvent } from "react";
import { SimpleSelectOption } from "./simpleSelectOptions";

type Props = {
  maxVisibleLength?: number;
  options: SimpleSelectOption[];
  values: SimpleSelectOption[];
  // setValues: (selected: SimpleSelectOption[]) => void;
  setValues: (getValues: (prevState: SimpleSelectOption[]) => SimpleSelectOption[]) => void;
  label?: string;
  widthFactor?: number | "100%";
  disabled?: boolean;
  maxHeight?: string;
};

export const ChipSelect = ({
  options,
  maxVisibleLength = 12,
  values,
  setValues,
  label,
  widthFactor = 1,
  disabled = false,
  maxHeight = "3.5em",
}: Props) => {
  const width = widthFactor === "100%" ? "100%" : 9 * widthFactor + "em";

  const onChange = (
    event: SyntheticEvent,
    values: string | SimpleSelectOption | readonly (string | SimpleSelectOption)[] | null,
    reason: AutocompleteChangeReason
  ): void => {
    if (reason === "blur") {
      return;
    }
    if (reason !== "selectOption") {
      console.error("Reason must be selectOption");
      return;
    }
    setValues(() => values as SimpleSelectOption[]);
  };

  const onDelete = (option: SimpleSelectOption): void => {
    setValues((prevState) => prevState.filter((value) => value.id !== option.id));
  };

  return (
    <FormControl sx={{ width }}>
      <Autocomplete<SimpleSelectOption, boolean, boolean, boolean>
        sx={{ width }}
        disabled={disabled}
        ListboxProps={{ style: { fontSize: ".75em" } }}
        options={options}
        getOptionLabel={(option) => {
          // noinspection SuspiciousTypeOfGuard
          if (typeof option === "string") {
            console.error("Option must not be a string");
            return "";
          }
          return option.value;
        }}
        multiple
        value={values}
        autoSelect
        clearOnBlur
        disableClearable
        filterSelectedOptions
        includeInputInList
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderTags={(values) => {
          return (
            <div style={{ overflow: "auto", maxHeight: maxHeight }}>
              {values?.map((value) => (
                <TooltipChip
                  key={value.id}
                  value={value.value}
                  maxVisibleLength={maxVisibleLength}
                  onDelete={disabled ? undefined : () => onDelete(value)}
                />
              ))}
            </div>
          );
        }}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            label={label}
            {...params}
            hiddenLabel
            InputProps={{
              ...params.InputProps,
              style: { fontSize: "1em" },
            }}
          />
        )}
      />
    </FormControl>
  );
};
